import WoundGoal from './WoundGoal';

export default WoundGoal;
